import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  currentStep: number;
  steps: string[];
}
const ProgressSteps = ({ currentStep = 1, steps }: IProps) => {
  return (
    <Container>
      {steps.map((step, i) => {
        const status =
          i + 1 === currentStep
            ? "active"
            : currentStep > i + 1
            ? "pass"
            : "null";
        return (
          <StepItem key={i}>
            <StepNo status={status}>
              {status === "pass" ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 19 18"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.5362 4.76351C15.7049 4.93228 15.7997 5.16116 15.7997 5.39981C15.7997 5.63846 15.7049 5.86733 15.5362 6.03611L8.33618 13.2361C8.1674 13.4048 7.93853 13.4996 7.69988 13.4996C7.46123 13.4996 7.23235 13.4048 7.06358 13.2361L3.46358 9.63611C3.29964 9.46637 3.20892 9.23902 3.21097 9.00305C3.21302 8.76707 3.30767 8.54134 3.47454 8.37447C3.64141 8.2076 3.86714 8.11295 4.10312 8.1109C4.33909 8.10885 4.56644 8.19957 4.73618 8.36351L7.69988 11.3272L14.2636 4.76351C14.4324 4.59478 14.6612 4.5 14.8999 4.5C15.1385 4.5 15.3674 4.59478 15.5362 4.76351Z"
                    fill="white"
                  />
                </svg>
              ) : (
                <Typography
                  color={status === "active" ? Colors.white100 : Colors.grey500}
                >
                  {i + 1}
                </Typography>
              )}
            </StepNo>
            <StepText active={status === "active" ? "true" : "false"}>
              <Typography
                weight="medium"
                size="lg"
                m_size="m"
                color={
                  status === "active"
                    ? Colors.white100
                    : status === "pass"
                    ? Colors.grey500
                    : Colors.grey600
                }
              >
                {step}
              </Typography>
            </StepText>
            {i + 1 !== steps.length && <Line />}
          </StepItem>
        );
      })}
    </Container>
  );
};

export default ProgressSteps;

const Container = styled.div`
  width: 100%;
  padding: 1.4rem;
  border-bottom: 1px solid ${Colors.grey700};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StepItem = styled.div`
  display: flex;
  align-items: center;
`;

const StepNo = styled.div<{ status: string }>`
  margin-right: 1rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  background-color: ${(props) =>
    props.status === "active"
      ? Colors.yellow400
      : props.status === "pass"
      ? Colors.success
      : Colors.grey600};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all ease-in-out 0.2s;
`;

const StepText = styled.div<{ active: string }>`
  @media only screen and (max-width: 769px) {
    display: ${(props) => (props.active === "true" ? "block" : "none")};
  }
`;
const Line = styled.div`
  margin: 0 0.8rem;
  border-top: 1px solid ${Colors.grey500};
  width: 3.2rem;
  @media only screen and (max-width: 769px) {
    width: 2.4rem;
    margin: 0 0.4rem;
  }
`;
